import React, { useState } from "react";
import { Warehouse, Search, PlusCircle, AlertTriangle } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "../components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";
import { useToast } from "../hooks/use-toast";

const Estoque = () => {
  const { produtos, estoqueEmpresa, entradaEstoqueEmpresa, getProduto } = useApp();
  const { toast } = useToast();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ produtoId: "", quantidade: "" });

  const rows = produtos
    .filter((p) => p.nome.toLowerCase().includes(q.toLowerCase()))
    .map((p) => ({ ...p, qtd: estoqueEmpresa[p.id] || 0 }));

  const handleEntrada = () => {
    if (!form.produtoId || !form.quantidade) return;
    entradaEstoqueEmpresa(form.produtoId, Number(form.quantidade));
    toast({ title: "Entrada registrada", description: `+${form.quantidade} un de ${getProduto(form.produtoId)?.nome}.` });
    setForm({ produtoId: "", quantidade: "" });
    setOpen(false);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">Estoque da Empresa</h1>
          <p className="text-slate-400 text-sm mt-0.5">Produtos usados quando o residente não possui fornecimento familiar</p>
        </div>
        <Button onClick={() => setOpen(true)} className="bg-blue-600 hover:bg-blue-700 gap-2">
          <PlusCircle className="w-4 h-4" /> Entrada de Estoque
        </Button>
      </div>

      <div className="flex items-center gap-2.5 px-3.5 py-2.5 rounded-lg bg-white border border-slate-200 max-w-sm">
        <Search className="w-4 h-4 text-slate-400" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar produto..."
          className="flex-1 bg-transparent outline-none text-sm text-slate-700" />
      </div>

      <div className="bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-slate-400 border-b border-slate-100">
                <th className="px-5 py-3 font-medium">Produto</th>
                <th className="px-5 py-3 font-medium">Categoria</th>
                <th className="px-5 py-3 font-medium">Mínimo</th>
                <th className="px-5 py-3 font-medium">Em estoque</th>
                <th className="px-5 py-3 font-medium">Situação</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {rows.map((p) => {
                const baixo = p.qtd < p.estoqueMinimo;
                return (
                  <tr key={p.id} className="hover:bg-slate-50/60">
                    <td className="px-5 py-3.5">
                      <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center">
                          <Warehouse className="w-4 h-4" />
                        </div>
                        <span className="font-medium text-slate-700">{p.nome}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-slate-500">{p.categoria}</td>
                    <td className="px-5 py-3.5 text-slate-500">{p.estoqueMinimo} {p.unidade}</td>
                    <td className="px-5 py-3.5 font-semibold text-slate-800">{p.qtd} {p.unidade}</td>
                    <td className="px-5 py-3.5">
                      {baixo ? (
                        <span className="inline-flex items-center gap-1 text-xs font-semibold text-amber-700 bg-amber-50 px-2 py-1 rounded-md">
                          <AlertTriangle className="w-3.5 h-3.5" /> Baixo
                        </span>
                      ) : (
                        <span className="text-xs font-semibold text-emerald-700 bg-emerald-50 px-2 py-1 rounded-md">Normal</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Entrada de Estoque</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div>
              <label className="text-sm font-medium text-slate-600 mb-1 block">Produto</label>
              <Select value={form.produtoId} onValueChange={(v) => setForm({ ...form, produtoId: v })}>
                <SelectTrigger><SelectValue placeholder="Selecione..." /></SelectTrigger>
                <SelectContent>
                  {produtos.map((p) => <SelectItem key={p.id} value={p.id}>{p.nome}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm font-medium text-slate-600 mb-1 block">Quantidade</label>
              <input type="number" min="1" value={form.quantidade}
                onChange={(e) => setForm({ ...form, quantidade: e.target.value })}
                className="w-full px-3.5 py-2.5 rounded-lg border border-slate-200 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm" />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button className="bg-blue-600 hover:bg-blue-700" onClick={handleEntrada}>Confirmar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Estoque;
